import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { Router } from '@angular/router'

import { CartService } from '../../../../services/cart.service'
import { I18nService, LgType } from '../../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-promo-block',
  templateUrl: './bmcore-promo-block.component.html',
  styleUrls: ['./bmcore-promo-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePromoBlockComponent implements OnInit {
  @Input() beatmakerId: number
  @Input() beatmakerName: string
  @Input() coupon = ''
  @Input() hasDiscount = false
  @Input() isBMSTVmode = false

  lg: LgType
  isCouponChecked = false
  disabled = true

  constructor(
    private cartService: CartService,
    private router: Router,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }

  checkCoupon() {
    this.cartService.setCoupon(this.beatmakerId, this.coupon)
    this.cartService.checkCoupon(this.beatmakerId).finally(() => {
      this.isCouponChecked = true
    })
  }

  changePromoCodeValue(event: Event) {
    this.coupon = (event.currentTarget as HTMLInputElement).value
    this.disabled = !this.coupon.trim()
  }

  toBeatmakerPage(beatmakerId: number) {
    this.router.navigate([`/bm/${beatmakerId}`])
  }
}
